function getBundleBuilderSpecialsTag() {
    const tag = window.bundleBuilderSpecials;
    return (typeof tag === 'string' && tag.trim()) ? tag.trim() : 'bundle builder';
}

function isBundleBuilderSectionItem(properties) {
    const props = properties || {};
    return props.specials === getBundleBuilderSpecialsTag();
}

function isFreeGiftRow(row) {
    return row && row.getAttribute('data-bb-free-gift') === 'true';
}

function getPaidSummaryRows() {
    return Array.prototype.filter.call(
        document.querySelectorAll('#bbt-added-items .zpro-bundle-summary-row'),
        function (row) { return !isFreeGiftRow(row); }
    );
}

function getFreeGiftTiersConfig() {
    const fromDom = [];
    document.querySelectorAll('#bb-free-gift-tiers .bb-free-gift-tier-data').forEach(function (el) {
        const variantId = Number(el.getAttribute('data-variant-id')) || 0;
        if (!variantId) return;
        fromDom.push({
            price_threshold: Number(el.getAttribute('data-threshold')) || 0,
            reward_type: 'free_gift',
            variant_id: variantId,
            gift_title: el.getAttribute('data-title') || 'Free gift',
            gift_image: el.getAttribute('data-image') || '',
            gift_compare_price: Number(el.getAttribute('data-compare-price')) || 0
        });
    });
    if (fromDom.length) return fromDom;
    return (window.bundleDiscountTiers || []).filter(function (t) {
        return (t.reward_type || '') === 'free_gift' && Number(t.variant_id) > 0;
    });
}

function getPaidSubtotalCents() {
    let totalBeforeDiscount = 0;
    getPaidSummaryRows().forEach(function (row) {
        const price = Number(row.getAttribute('data-bb-price')) || 0;
        const quantity = Number(row.getAttribute('data-bb-added-qty')) || 0;
        totalBeforeDiscount += (price * quantity) / 100;
    });
    return Math.floor(totalBeforeDiscount * 100);
}

function getEligibleFreeGiftTier(subtotalCents) {
    const rate = window.bundleCurrencyRate || 1;
    const tiers = getFreeGiftTiersConfig().sort(function (a, b) {
        return (a.price_threshold || 0) - (b.price_threshold || 0);
    });
    let eligible = null;
    for (let i = 0; i < tiers.length; i++) {
        const thresholdCents = Math.round((tiers[i].price_threshold || 0) * rate);
        if (subtotalCents >= thresholdCents) {
            eligible = tiers[i];
        }
    }
    return eligible;
}

function buildFreeGiftRowHtml(tier) {
    const variantId = String(tier.variant_id);
    const title = tier.gift_title || 'Free gift';
    const imgUrl = tier.gift_image || '';
    const compareCents = Number(tier.gift_compare_price) || 0;
    const currencySymbol = window.currencySymbol || '$';
    const compareText = compareCents > 0 ? currencySymbol + (compareCents / 100).toFixed(2) : '';
    const imgSmall = imgUrl && imgUrl.indexOf('shopify') !== -1
        ? imgUrl.replace(/_\d+x\d*(\.[a-z]+)/i, '_100x100$1').replace(/\?[^#]+/, '')
        : imgUrl;

    return '<div class="zpro-bundle-summary-row bb-free-gift-row" data-bb-added-id="' + variantId + '" data-bb-added-qty="1" data-bb-price="0" data-bb-compare-price="' + compareCents + '" data-bb-image="' + (imgUrl || '') + '" data-bb-free-gift="true">' +
        '<div class="bbsr-img"><img src="' + (imgSmall || imgUrl) + '" alt="" width="48" height="48" loading="lazy" /></div>' +
        '<div class="bbsr-title">' + escapeHtml(title) + '<span class="bbsr-gift-badge">FREE GIFT</span></div>' +
        '<div class="bbsr-qty"><span>1</span>x</div>' +
        '<div class="bbsr-price"><div class="bbsr-price-org">' + currencySymbol + '0.00</div><s class="bbsr-price-comp">' + escapeHtml(compareText) + '</s></div>' +
        '</div>';
}

function syncBundleFreeGift() {
    const container = document.querySelector('#bbt-added-items');
    if (!container) return;

    const subtotalCents = getPaidSubtotalCents();
    const eligibleTier = getEligibleFreeGiftTier(subtotalCents);
    const existingGift = container.querySelector('[data-bb-free-gift="true"]');

    if (!eligibleTier) {
        if (existingGift) existingGift.remove();
        return;
    }

    const targetVariantId = String(eligibleTier.variant_id);
    if (existingGift) {
        if (existingGift.getAttribute('data-bb-added-id') === targetVariantId) return;
        existingGift.remove();
    }

    container.insertAdjacentHTML('beforeend', buildFreeGiftRowHtml(eligibleTier));
}

// document.querySelectorAll('.zpro-bundle-summary-wraps').forEach((el, i) => i < 3 && document.querySelector('.bbt-details').insertAdjacentHTML('beforeend', el.innerHTML));

//above is temperery

// Call the function on page load
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBundleSliders);
} else {
    initBundleSliders();
}

setTimeout(updateBundleCardQty, 1000);

// Format threshold amount: 2 decimals when there are cents (34.9 → "34.90"), no decimals for whole numbers (50 → "50")
function formatThresholdAmount(num) {
    const n = parseFloat(num);
    if (isNaN(n)) return '';
    if (Number.isInteger(n)) return String(n);
    return n.toFixed(2);
}

// Initialise bundle progress bar and threshold labels (currency rate) on load
function initBundleProgressOnLoad() {
    calculateBBitems();
    const rate = window.bundleCurrencyRate;
    document.querySelectorAll('.bb-threshold-amount').forEach(function (span) {
        const original = parseFloat(span.getAttribute('data-bb-threshold')) || 0;
        const displayVal = (rate && rate !== 1) ? (Math.round(original * rate * 100) / 100) : original;
        span.textContent = formatThresholdAmount(displayVal);
    });
    restoreBundleFromCart();
}
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBundleProgressOnLoad);
} else {
    initBundleProgressOnLoad();
}

// Restore bundle builder area from cart on page load: items with line item property specials = "bundle builder"
// Adds each item with a delay so the UI updates progressively (rack, totals, progress bar)
function restoreBundleFromCart() {
    const container = document.querySelector('#bbt-added-items');
    if (!container || !document.querySelector('.bundle-collection-wrapper')) return;

    fetch('/cart.js')
        .then(function (res) { return res.json(); })
        .then(function (cart) {
            var items = cart.items || [];
            var bundleItems = items.filter(function (item) {
                var props = item.properties || {};
                if (props._bundle_free_gift === 'true' || props['_bundle_free_gift'] === 'true') return false;
                return isBundleBuilderSectionItem(props);
            });
            if (bundleItems.length === 0) return;

            var currencySymbol = window.currencySymbol || (cart.currency && cart.currency !== '' ? cart.currency + ' ' : '$');
            var delayMs = 400;
            var index = 0;

            function formatMoney(cents) {
                return currencySymbol + (Math.round(cents) / 100).toFixed(2);
            }

            function addNext() {
                if (index >= bundleItems.length) {
                    updateBundleCardQty();
                    return;
                }
                var item = bundleItems[index];
                var variantId = String(item.variant_id);
                var qty = Math.max(1, parseInt(item.quantity, 10) || 1);
                var priceCents = parseInt(item.price, 10) || 0;
                var imgUrl = item.image || (item.featured_image && item.featured_image.url) || '';
                var title = item.title || item.product_title || '';

                var img800 = imgUrl;
                var img100 = imgUrl;
                var restoreEl = document.querySelector('#bb-restore-image-data [data-variant-id="' + variantId + '"]');
                if (restoreEl) {
                    if (restoreEl.getAttribute('data-bb-image')) img800 = restoreEl.getAttribute('data-bb-image');
                    if (restoreEl.getAttribute('data-bb-img-small')) img100 = restoreEl.getAttribute('data-bb-img-small');
                } else if (imgUrl && imgUrl.indexOf('shopify') !== -1 && imgUrl.indexOf('_') !== -1) {
                    img100 = imgUrl.replace(/_\d+x\d*(\.[a-z]+)/i, '_100x100$1').replace(/\?[^#]+/, '');
                }

                var rowHtml =
                    '<div class="zpro-bundle-summary-row" data-bb-added-id="' + variantId + '" data-bb-added-qty="' + qty + '" data-bb-price="' + priceCents + '" data-bb-image="' + (img800 || '') + '">' +
                    '<div class="bbsr-img"><img src="' + (img100 || imgUrl) + '" alt="" width="48" height="48" loading="lazy" /></div>' +
                    '<div class="bbsr-title">' + escapeHtml(title) + '</div>' +
                    '<div class="bbsr-qty"><span>' + qty + '</span>x</div>' +
                    '<div class="bbsr-price"><div class="bbsr-price-org">' + formatMoney(priceCents) + '</div><s class="bbsr-price-comp"></s></div>' +
                    '<div class="bbsr-close bbsr-remove"></div></div>';

                container.insertAdjacentHTML('beforeend', rowHtml);
                calculateBBitems();
                index += 1;
                if (index < bundleItems.length) {
                    setTimeout(addNext, delayMs);
                } else {
                    updateBundleCardQty();
                }
            }

            addNext();
        })
        .catch(function () {});
}

function escapeHtml(text) {
    if (!text) return '';
    var div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
}


//run this after each ajax product call and add item
function initBundleSliders() {
    // Select all elements with the class 'jspcimg-slider'
    var sliders = document.querySelectorAll('.bundimg-slider');
    sliders.forEach(function(slider) {
        // Check if Flickity is available and slider not already initialized
        if (typeof Flickity !== 'undefined' && !slider.classList.contains('flickity-enabled')) {
            // Initialize Flickity slider
            new Flickity(slider, {
                cellAlign: 'left',
                contain: true,
                pageDots: true,
                prevNextButtons: false,
                imagesLoaded: true,
                wrapAround: true
            });
            // Remove the class to prevent re-initialization
            slider.classList.remove('bundimg-slider');
        }
    });
}

function updateBundleCardQty()
{

    const addedItems = document.querySelectorAll('#bbt-added-items [data-bb-added-id]:not([data-bb-free-gift="true"])');
    // Loop through each added item
    for (let i = 0; i < addedItems.length; i++) {
        const item = addedItems[i];
        if (!item) continue;

        // Get the variant ID from data-bb-added-id
        const variantId = item.getAttribute('data-bb-added-id');

        // Get the quantity from data-bb-added-qty
        const quantity = item.getAttribute('data-bb-added-qty');

        if (!variantId) continue;

        // Find the matching element in .fsb-products with the same variant ID
        const matchingElement = document.querySelector(`.fsb-products [data-bbvariant-id="${variantId}"].bbadd-var`);

        if (matchingElement) {
            // Add 'selected' class to the matching element
            matchingElement.classList.add('selected');

            // INSERT_YOUR_CODE
            if (quantity == 0) {
                matchingElement.classList.remove('selected');
            }


            // Find the quantity input child and update its value
            const quantityInput = matchingElement.querySelector('.quantity__input');
            if (quantityInput && quantityInput instanceof HTMLInputElement) {
                quantityInput.value = quantity || '0';
            }
        }
    }
}


// Bundle qty +/- : handle in capture phase so theme-custom.js body listener (.plus-minus .plus/.minus) does not also run
document.addEventListener('click', function (event) {
    const qtyButton = event.target.closest('[data-bbqty-change]');
    if (qtyButton) {
        event.preventDefault();
        event.stopPropagation();
        const action = qtyButton.getAttribute('data-bbqty-change');
        const inputElement = qtyButton.parentElement.querySelector('input');
        if (inputElement) {
            let currentValue = parseInt(inputElement.value) || 0;
            if (action === 'dec') {
                currentValue = Math.max(0, currentValue - 1);
            } else if (action === 'inc') {
                currentValue += 1;
            }
            inputElement.value = currentValue;
            inputElement.dispatchEvent(new Event('change', { bubbles: true }));
        }
    }
}, true);

//all click events
document.addEventListener('click', function (event) {
    //bb pagination click ajax call
    const clickedLink = event.target.closest('a.bb-next');
    if(clickedLink)
    {
        const newUrl = clickedLink.href;
        event.preventDefault();
        clickedLink.textContent = 'LOADING...';

        // Fetch content from the new URL (use bundle builder section for consistency)
        const sectionId = document.querySelector('.bundle-collection-wrapper')?.getAttribute('data-section-id') || 'zpro-bundle-collection-s';
        const requestUrl = `${newUrl}&section_id=${sectionId}`;
        console.log(requestUrl);
        fetch(requestUrl)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.text();
            })
            .then(html => {
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = html;

                // When using bundle builder section id, response is full section; .fsb-products is inside .bb-collection-ajax
                const newProducts = tempDiv.querySelector('.fsb-products');
                if (newProducts) {
                    const currentProducts = document.querySelector('.fsb-products');
                    if (currentProducts) {
                        currentProducts.insertAdjacentHTML('beforeend', newProducts.innerHTML);
                    }
                }

                const newPagination = tempDiv.querySelector('.jl-pagination');
                if (newPagination) {
                    const currentPagination = document.querySelector('.jl-pagination');
                    if (currentPagination) {
                        currentPagination.innerHTML = newPagination.innerHTML;
                    }
                }
                initBundleSliders();
                updateBundleCardQty();
            })
            .catch(error => {
                console.error('Error loading content:', error);
            });
    }

    //BB filter collection click
    const bundleFilterLink = event.target.closest('.bundle-filter-link');
    if (bundleFilterLink) {
        event.preventDefault();
        const bundleFilters = bundleFilterLink.closest('.bundle-filters');
        if (bundleFilters) {
            bundleFilters.querySelectorAll('.bundle-filter-link').forEach(link => {
                link.classList.remove('active');
            });
            bundleFilterLink.classList.add('active');
            fetchBundleCollection(bundleFilterLink.href);
        }
    }



    //when click bb cards swatch
    const bbvThumb = event.target.closest('.bbv-thumb');
    if (bbvThumb) {
        event.preventDefault();
        const variantId = bbvThumb.getAttribute('data-bbvariant-id');
        const parentItem = bbvThumb.closest('.jlc-item');

        if (parentItem && variantId) {
            // Remove active class from all variant elements
            parentItem.querySelectorAll('[data-bbvariant-id]').forEach(el => {
                el.classList.remove('active');
            });

            // Add active class to matching variant elements
            parentItem.querySelectorAll(`[data-bbvariant-id="${variantId}"]`).forEach(el => {
                el.classList.add('active');
            });
        }
    }

    //when click select in bb card
    const addStyleButton = event.target.closest('.jspc-add-style');
    if (addStyleButton) {
        const parentVar = addStyleButton.closest('.bbadd-var');
        if (parentVar) {
            const qtyInput = parentVar.querySelector('.qty-input');
            if (qtyInput) {
                qtyInput.value = '1';
                qtyInput.dispatchEvent(new Event('change', {bubbles: true}));
            }
        }
    }

    // Handle remove button in bundle summary row
    if (event.target && typeof event.target.closest === 'function') {
        const removeBtn = event.target.closest('.bbsr-remove');
        if (removeBtn) {
            event.preventDefault();
            const summaryRow = removeBtn.closest('.zpro-bundle-summary-row');
            if (summaryRow && isFreeGiftRow(summaryRow)) return;
            if (summaryRow) {
                const id = summaryRow.getAttribute('data-bb-added-id');
                if (id) {
                    updateBBitems(id, 0);
                }
            }
        }
    }
    // Handle checkout button click
    const checkoutBtn = event.target.closest('.bb-checkout-btn');
    if (checkoutBtn) {
        event.preventDefault();
        if (typeof runBBCheckout === 'function') {
            runBBCheckout();
        }
    }
// Handle open/close bundle (bbt-drop, bbt-op): toggle panel and lock/unlock body scroll
    const openBtn = event.target.closest('.bbt-op');
    if (openBtn) {
        event.preventDefault();
        const bundleWrapper = document.querySelector('.bundle-collection-wrapper');
        if (bundleWrapper) {
            bundleWrapper.classList.toggle('bbopen');
            document.body.style.overflow = bundleWrapper.classList.contains('bbopen') ? 'hidden' : '';
        }
    }
    // On mobile only: clicking .bb-progress-bar also opens the bundle panel
    const progressBar = event.target.closest('.bb-progress-bar');
    if (progressBar && window.innerWidth <= 900) {
        event.preventDefault();
        const bundleWrapper = document.querySelector('.bundle-collection-wrapper');
        if (bundleWrapper && !bundleWrapper.classList.contains('bbopen')) {
            bundleWrapper.classList.add('bbopen');
            document.body.style.overflow = 'hidden';
        }
    }


});

function runBBCheckout()
{
    syncBundleFreeGift();

    const checkoutButtons = document.querySelectorAll('.bb-checkout-btn');
    const loadingText = 'Loading…';

    checkoutButtons.forEach(btn => {
        btn.classList.add('inactive');
        btn.setAttribute('data-bb-checkout-original', btn.innerHTML);
        btn.innerHTML = loadingText;
    });

    function enableButtons() {
        checkoutButtons.forEach(btn => {
            btn.classList.remove('inactive');
            var original = btn.getAttribute('data-bb-checkout-original');
            if (original) {
                btn.innerHTML = original;
                btn.removeAttribute('data-bb-checkout-original');
            }
        });
    }

    const addedItems = document.querySelectorAll('#bbt-added-items [data-bb-added-id]');
    if (getPaidSummaryRows().length === 0) {
        console.warn('No items found in bundle builder');
        enableButtons();
        return;
    }

    const skipFreeGiftInCart = !!window.bundleDontAddFreeGift;
    const eligibleGiftTier = getEligibleFreeGiftTier(getPaidSubtotalCents());

    // Prepare items array for batch add
    const itemsToAdd = [];
    for (let i = 0; i < addedItems.length; i++) {
        const item = addedItems[i];
        const variantId = item.getAttribute('data-bb-added-id');
        const quantity = parseInt(item.getAttribute('data-bb-added-qty'), 10) || 1;
        const isGift = isFreeGiftRow(item);
        if (!variantId || quantity <= 0) continue;
        if (isGift && skipFreeGiftInCart) continue;
        if (isGift && !eligibleGiftTier) continue;
        if (isGift && String(eligibleGiftTier.variant_id) !== String(variantId)) continue;

        const properties = { 'specials': getBundleBuilderSpecialsTag() };
        if (isGift) properties['_bundle_free_gift'] = 'true';

        itemsToAdd.push({
            id: variantId,
            quantity: quantity,
            properties: properties
        });
    }
    if (itemsToAdd.length === 0) {
        console.warn('No valid items to add to cart');
        enableButtons();
        return;
    }

    // Step 1: Fetch cart and remove only line items with specials: 'bundle builder'
    fetch('/cart.js')
        .then(function (res) { return res.json(); })
        .then(function (cart) {
            var updates = {};
            var items = cart.items || [];
            items.forEach(function (item) {
                var props = item.properties || {};
                if (isBundleBuilderSectionItem(props)) {
                    updates[item.variant_id] = 0;
                }
            });
            if (Object.keys(updates).length === 0) {
                return Promise.resolve(null);
            }
            var body = Object.keys(updates).map(function (vid) {
                return 'updates[' + vid + ']=0';
            }).join('&');
            return fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: body
            }).then(function (r) { return r.json(); });
        })
        .then(function () {
            // Step 2: Add current bundle items
            return fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: itemsToAdd })
            });
        })
        .then(function (response) {
            if (!response) {
                enableButtons();
                return;
            }
            if (!response.ok) {
                throw new Error('Failed to add items to cart');
            }
            return response.json();
        })
        .then(function () {
            window.location.href = '/checkout';
        })
        .catch(function (error) {
            console.error('Error during checkout process:', error);
            enableButtons();
            alert('There was an error processing your checkout. Please try again.');
        });
}

//handle input changes for dynamically loaded content
document.addEventListener('change', function (event) {
    const ChangedItem = event.target;

    if (ChangedItem.classList && ChangedItem.classList.contains('bb-variant-select')) {
        const variantId = ChangedItem.value;
        const parentItem = ChangedItem.closest('.jlc-item');
        if (parentItem && variantId) {
            parentItem.querySelectorAll('[data-bbvariant-id]').forEach(function (el) {
                el.classList.remove('active');
            });
            parentItem.querySelectorAll('[data-bbvariant-id="' + variantId + '"]').forEach(function (el) {
                el.classList.add('active');
            });
        }
        return;
    }

    if (ChangedItem.classList.contains('bbtcard-qty')) {
            const variantId = ChangedItem.getAttribute('data-bb-varid');
        const qtyInput = ChangedItem.value;
            if (variantId) {
                updateBBitems(variantId, qtyInput);
            }
    }
});

//call change or add bb item
function updateBBitems(id,qt)
{

    const addedItemsContainer = document.querySelector('#bbt-added-items');

    if (!addedItemsContainer) return;
    // Check if item already exists with data-bb-added-id
    let existingItem = addedItemsContainer.querySelector(`[data-bb-added-id="${id}"]:not([data-bb-free-gift="true"])`);

    if (existingItem) {

        // Update quantity if item exists
        const qtyElement = existingItem.querySelector('.bbsr-qty span');
        if (qtyElement) {
            qtyElement.textContent = qt;
        }
        existingItem.setAttribute('data-bb-added-qty', qt);

        if (qt == 0) {
            if (existingItem) {
                updateBundleCardQty();
                existingItem.remove();
            }
        }


    } else {
        // Check for element with data-bbvariant-id
        const addedIdElement = document.querySelector(`[data-bbvariant-id="${id}"] .zpro-bundle-summary-wraps`);

            if (addedIdElement) {
                    addedItemsContainer.insertAdjacentHTML('beforeend', addedIdElement.innerHTML);
                    updateBundleCardQty()
            }

    }
    calculateBBitems();
}

function calculateBBitems()
{
    syncBundleFreeGift();

    const paidRows = getPaidSummaryRows();
    let itemCount = 0;
    for (let i = 0; i < paidRows.length; i++) {
        const item = paidRows[i];
        if (!item) continue;
        const quantity = Number(item.getAttribute('data-bb-added-qty'));
        if (quantity <= 0) continue;
        itemCount += quantity;
    }

    // Update bbt-title item count (e.g. "4 items")
    const itemCountEl = document.querySelector('[data-bb-item-count]');
    if (itemCountEl) {
        itemCountEl.textContent = itemCount === 1 ? '1 item' : itemCount + ' items';
    }

     const summaryRows = paidRows;
     const allSummaryRows = document.querySelectorAll('#bbt-added-items .zpro-bundle-summary-row');

     // Initialize totals
     let totalBeforeDiscount = 0;
     let totalDiscounted = 0;
     const currencySymbol = window.currencySymbol || '';

     // First pass: compute subtotal (price before discount) from section blocks
     for (let i = 0; i < summaryRows.length; i++) {
         const row = summaryRows[i];
         if (!row) continue;
         const price = Number(row.getAttribute('data-bb-price')) || 0;
         const quantity = Number(row.getAttribute('data-bb-added-qty')) || 0;
         totalBeforeDiscount += (price * quantity) / 100;
     }

     // Determine applicable discount from blocks (based on subtotal before discount)
     const tiers = (window.bundleDiscountTiers || []).slice().sort((a, b) => (a.price_threshold || 0) - (b.price_threshold || 0));
     const subtotalCents = Math.floor(totalBeforeDiscount * 100);
     let discountValue = 0;
     for (let t = 0; t < tiers.length; t++) {
         if (subtotalCents >= (tiers[t].price_threshold || 0) && (tiers[t].reward_type || '') === 'discount_threshold') {
             discountValue = Number(tiers[t].discount_percentage) || 0;
         }
     }
     // Free gift rows: always show $0 with compare price
     for (let g = 0; g < allSummaryRows.length; g++) {
         const giftRow = allSummaryRows[g];
         if (!isFreeGiftRow(giftRow)) continue;
         const compareCents = Number(giftRow.getAttribute('data-bb-compare-price')) || 0;
         const priceElement = giftRow.querySelector('.bbsr-price-org');
         const comparePriceElement = giftRow.querySelector('.bbsr-price-comp');
         if (priceElement) priceElement.textContent = currencySymbol + '0.00';
         if (comparePriceElement) {
             comparePriceElement.textContent = compareCents > 0 ? currencySymbol + (compareCents / 100).toFixed(2) : '';
         }
     }

     // Second pass: row totals with discount and row UI updates
     for (let i = 0; i < summaryRows.length; i++) {
         const row = summaryRows[i];
         if (!row) continue;

         const price = Number(row.getAttribute('data-bb-price')) || 0;
         const quantity = Number(row.getAttribute('data-bb-added-qty')) || 0;
         const originalTotal = (price * quantity) / 100;

         let discountedTotal = originalTotal;
         if (discountValue && discountValue > 0) {
             const discountSingle = (Math.ceil(price * (1 - discountValue / 100)) / 100).toFixed(2);
             discountedTotal = discountSingle * quantity;
         }

         totalDiscounted += discountedTotal;

        // Format to 2 decimal places
        const formattedOriginal = originalTotal.toFixed(2);
        // Use ceiling (round up) for discounted total, then format to 2 decimal places
        const formattedDiscounted = (Math.ceil(discountedTotal * 100) / 100).toFixed(2);

        // Find .bbsr-price-org and update with discounted price
        const priceElement = row.querySelector('.bbsr-price-org');
        if (priceElement) {
            priceElement.textContent = currencySymbol + formattedDiscounted;
        }

        // Find .bbsr-price-comp and update with original price
        const comparePriceElement = row.querySelector('.bbsr-price-comp');
        if (comparePriceElement) {
            if (discountValue && discountValue > 0 && discountedTotal < originalTotal) {
                comparePriceElement.textContent = currencySymbol + formattedOriginal;
            } else {
                comparePriceElement.textContent = '';
            }
        }
     }

     // Update total compare price (before discount) - update all matching elements
     // Only show compare price if discounted price is different from original price
     const totalCompareElements = document.querySelectorAll('.data-bb-total-compare');
     const comparePriceValue = (totalBeforeDiscount > 0 && totalBeforeDiscount !== totalDiscounted) ? totalBeforeDiscount.toFixed(2) : '';
     const comparePriceText = comparePriceValue ? currencySymbol + comparePriceValue : '';
     for (let i = 0; i < totalCompareElements.length; i++) {
         const el = totalCompareElements[i];
         if (el) {
             el.textContent = comparePriceText;
         }
     }

     // Update total price (discounted) - update all matching elements
     const totalPriceElements = document.querySelectorAll('.data-bb-total-price');
     const totalPriceText = currencySymbol + totalDiscounted.toFixed(2);
     for (let i = 0; i < totalPriceElements.length; i++) {
         const el = totalPriceElements[i];
         if (el) {
             el.textContent = totalPriceText;
         }
     }

     // Price summary: Subtotal (before discount), Saving, Shipping (only when past threshold), Total (discounted)
     const subtotalEl = document.querySelector('[data-bb-subtotal]');
     if (subtotalEl) subtotalEl.textContent = currencySymbol + totalBeforeDiscount.toFixed(2);
     const savingRow = document.querySelector('.bbt-summary-saving');
     const savingVal = document.querySelector('[data-bb-saving]');
     const savingAmount = totalBeforeDiscount - totalDiscounted;
     if (savingRow && savingVal) {
         if (savingAmount > 0) {
             savingRow.style.display = '';
             savingVal.textContent = currencySymbol + savingAmount.toFixed(2);
         } else {
             savingRow.style.display = 'none';
         }
     }
     const shippingRow = document.querySelector('.bbt-summary-shipping');
     const shippingThresholdCents = window.bundleShippingThresholdCents != null ? window.bundleShippingThresholdCents : 999999999;
     if (shippingRow) {
         if (subtotalCents >= shippingThresholdCents) {
             shippingRow.style.display = '';
         } else {
             shippingRow.style.display = 'none';
         }
     }
     const totalSummaryEl = document.querySelector('[data-bb-total-summary]');
     if (totalSummaryEl) totalSummaryEl.textContent = totalPriceText;

     // Update price and compare price inside .bbc-price (checkout buttons)
     const bbcPriceContainers = document.querySelectorAll('.bb-checkout-btn .bbc-price');
     for (let i = 0; i < bbcPriceContainers.length; i++) {
         const container = bbcPriceContainers[i];
         if (!container) continue;
         const priceEl = container.querySelector('.bbc-price-value');
         const compareEl = container.querySelector('.bbc-compare-price');
         if (priceEl) priceEl.textContent = totalPriceText;
         if (compareEl) {
             compareEl.textContent = comparePriceText;
             compareEl.style.display = comparePriceText ? '' : 'none';
         }
     }

     // Update checkout button state based on minActivateItems
     const checkoutButtons = document.querySelectorAll('.bb-checkout-btn');
     const minActivateItems = window.minActivateItems || 0;
     if (itemCount >= minActivateItems) {
         // Remove inactive class if item count meets minimum requirement
         checkoutButtons.forEach(btn => {
             btn.classList.remove('inactive');
         });
     } else {
         // Add inactive class if item count is below minimum requirement
         checkoutButtons.forEach(btn => {
             btn.classList.add('inactive');
         });
     }

     // Sync .bb-product-rack: only remove images no longer in target, only add new images at correct index (no full rebuild – keeps animation on existing)
     const rack = document.querySelector('.bb-product-rack');
     if (rack) {
         var target = [];
         allSummaryRows.forEach(function (row) {
             const variantId = row.getAttribute('data-bb-added-id');
             const imgUrl = row.getAttribute('data-bb-image');
             const qty = Math.max(0, parseInt(row.getAttribute('data-bb-added-qty'), 10) || 1);
             if (!imgUrl || !variantId) return;
             for (var ui = 0; ui < qty; ui++) {
                 target.push({ variantId: variantId, unitIndex: ui, imgUrl: imgUrl });
             }
         });
         var targetKeySet = {};
         target.forEach(function (t) { targetKeySet[t.variantId + '-' + t.unitIndex] = true; });
         var rackImgs = Array.prototype.slice.call(rack.querySelectorAll('img'));
         rackImgs.forEach(function (img) {
             var key = img.getAttribute('data-bb-added-id') + '-' + img.getAttribute('data-bb-unit-index');
             if (!targetKeySet[key]) img.remove();
         });
         var currentKeys = {};
         Array.prototype.forEach.call(rack.querySelectorAll('img'), function (img) {
             var key = img.getAttribute('data-bb-added-id') + '-' + img.getAttribute('data-bb-unit-index');
             currentKeys[key] = true;
         });
         var toAdd = [];
         target.forEach(function (t, i) {
             var key = t.variantId + '-' + t.unitIndex;
             if (!currentKeys[key]) toAdd.push({ entry: t, index: i });
         });
         var created = [];
         toAdd.forEach(function (item) {
             var t = item.entry;
             var img = document.createElement('img');
             img.alt = '';
             img.loading = 'lazy';
             img.setAttribute('data-bb-added-id', t.variantId);
             img.setAttribute('data-bb-unit-index', String(t.unitIndex));
             img.src = t.imgUrl;
             var insertBeforeEl = rack.children[item.index] || null;
             rack.insertBefore(img, insertBeforeEl);
             created.push(img);
         });
         rack.setAttribute('data-bb-count', String(target.length));
         var contentParent = rack.closest('.bbt-content');
         if (contentParent) contentParent.setAttribute('data-bb-count', String(target.length));
         created.forEach(function (img) {
             if (img !== created[created.length - 1]) img.classList.add('bb-rack-loaded');
         });
         Array.prototype.forEach.call(rack.querySelectorAll('img'), function (img) {
             if (created.indexOf(img) === -1) img.classList.add('bb-rack-loaded');
         });
         var lastCreated = created[created.length - 1];
         if (lastCreated) {
             function animateLastRackImage() {
                 requestAnimationFrame(function () {
                     requestAnimationFrame(function () {
                         setTimeout(function () {
                             lastCreated.classList.add('bb-rack-loaded');
                         }, 80);
                     });
                 });
             }
             lastCreated.addEventListener('load', animateLastRackImage);
             if (lastCreated.complete) animateLastRackImage();
         }
     }

     // Update discount tier progress bar (use subtotal / price before discount from blocks)
     const progressBarWrap = document.querySelector('.bb-progress-bar');
     if (progressBarWrap) {
         const rate = window.bundleCurrencyRate || 1;
         // Use subtotal (before discount) so progress bar reflects threshold from section blocks
         const totalCents = Math.floor(totalBeforeDiscount * 100);
         const bbProgressTrack = progressBarWrap.querySelector('.bb-progress-track');
         const nsProgressFill = progressBarWrap.querySelector('.bb-progress-fill');
         const locks = progressBarWrap.querySelectorAll('.bb-target-locks .bb-target');
         if (bbProgressTrack) bbProgressTrack.setAttribute('data-progress', totalCents);
         if (locks.length === 0) return;
         let currentTarget = null;
         let nextTarget = null;
         locks.forEach((el, i) => {
             el.classList.remove('active');
             const targetCents = (Number(el.getAttribute('data-target')) || 0) * rate;
             if (totalCents >= targetCents) {
                 el.classList.add('active');
                 currentTarget = { el, i, targetCents };
                 nextTarget = locks[i + 1] || null;
             }
         });
         if (nsProgressFill) {
             // .bb-target-locks uses justify-content: space-around → first/last gaps are half of center gaps
             // So lock i (0-based) is at (i + 0.5) * (100/n), e.g. 4 locks → 12.5%, 37.5%, 62.5%, 87.5%
             const n = locks.length;
             const segmentLen = n > 0 ? 100 / n : 100;
             function lockPosition(i) {
                 return (i + 0.5) * segmentLen;
             }
             if (nextTarget && currentTarget) {
                 const nextCents = (Number(nextTarget.getAttribute('data-target')) || currentTarget.targetCents) * rate;
                 let extraval = (totalCents - currentTarget.targetCents) / Math.max(1, nextCents - currentTarget.targetCents);
                 extraval = Math.min(1, extraval);
                 const startPos = lockPosition(currentTarget.i);
                 const endPos = lockPosition(currentTarget.i + 1);
                 const barwidth = Math.min(100, startPos + (endPos - startPos) * extraval);
                 nsProgressFill.style.width = barwidth + '%';
             } else if (currentTarget) {
                 nsProgressFill.style.width = '100%';
             } else {
                 // No tier reached yet: fill from 0 to first lock position (12.5% for 4 locks) by item count
                 const firstLockPos = lockPosition(0);
                 const barwidth = itemCount > 0 ? Math.min(firstLockPos, itemCount * 2) : 0;
                 nsProgressFill.style.width = barwidth + '%';
             }
         }
     }

    syncBundleFreeGift();
}



function fetchBundleCollection(url)
{
    // Filter links use collection URLs - must use zpro-bundle-collection-s so collection comes from request (filters work)
    // Bundle builder section uses section.settings.collection and ignores URL, so filters would not work
    const requestUrl = `${url}&section_id=zpro-bundle-collection-s`;

    // Fetch the content
    fetch(requestUrl)
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.text();
        })
        .then(html => {
            // Create a temporary DOM element to parse the response
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = html;

            // Extract and insert content for the '.collection' class
            const collectionContent = tempDiv.querySelector('.bb-collection-ajax');
            if (collectionContent) {
                const collectionWrap = document.querySelector('.bb-collection-ajax');
                if (collectionWrap) {
                    collectionWrap.innerHTML = collectionContent.innerHTML;
                }
            }


            initBundleSliders();
            updateBundleCardQty();
            window.scrollTo(0, 0);

        })
        .catch(error => {
            console.error('Error loading content:', error);
        });
}





